import { useContext, useEffect } from "react"
import { useHistory } from "react-router-dom"
import SiteContext from "../../contexts/SiteContext"
import Cabecalho from "../Global/cabecalho"
import Rodape from "../Global/rodape"
import Cardapio from "./cardapio"
import Estabelecimento from "./estabelecimento"
import "./styles.css"

export default function Delivery(props) {
    const search = props.location.search
    const params = new URLSearchParams(search)
    const visualizacaoParams = params.get("view")

    const history = useHistory()
    const usuarioPedidoMesa = JSON.parse(localStorage.getItem("usuarioPedidoMesaCF"))
    const {
        aplicativoDados,
        setAplicativoDados,

        estabelecimentoAtual,
        setEstabelecimentoAtual,

        usuarioLogado,
        setUsuarioLogado,

        cardapio,

        carrinho,
    } = useContext(SiteContext)

    useEffect(() => {
        window.dispatchEvent(new CustomEvent("chegueiNoDelivery"))
    }, [])

    const mostrarWhatsapp =
        estabelecimentoAtual &&
        estabelecimentoAtual.numeroWhatsapp &&
        aplicativoDados.mostrarWhatsapp
            ? estabelecimentoAtual.numeroWhatsapp
            : null

    // console.log('!estabelecimentoAtual || !carrinho || !cardapio', !estabelecimentoAtual ,!carrinho, !cardapio)
    if (!estabelecimentoAtual || !carrinho) {
        if (!estabelecimentoAtual) {
            console.log("Return Empty Page Delivery: ")
            history.push(`/`)
            //return (null)

            return <></>
        }
        return <></>
    }

    return (
        <>
            {!visualizacaoParams ? (
                usuarioPedidoMesa?.logado ? (
                    <Cabecalho
                        mesa={usuarioLogado.cliente.nome}
                        mostrarWhatsapp={mostrarWhatsapp}
                    ></Cabecalho>
                ) : aplicativoDados.clienteFielStart ? (
                    <Cabecalho
                        clienteFielStart={true}
                        mostrarWhatsapp={mostrarWhatsapp}
                    ></Cabecalho>
                ) : (
                    <Cabecalho
                        nomeEstabelecimentoCardapio={true}
                        statusEstabelecimento={true}
                        mostrarWhatsapp={mostrarWhatsapp}
                    ></Cabecalho>
                )
            ) : (
                <Cabecalho mostrarWhatsapp={mostrarWhatsapp} visualizacao={true}></Cabecalho>
            )}

            <div className="container container-delivery">
                <Estabelecimento visualizacao={visualizacaoParams ? true : false}></Estabelecimento>
                <Cardapio
                    visualizacao={visualizacaoParams ? true : false}
                    mostrarWhatsapp={mostrarWhatsapp}
                ></Cardapio>
            </div>

            {aplicativoDados.clienteFielStart || visualizacaoParams ? null : (
                <Rodape valor="Delivery"></Rodape>
            )}
        </>
    )
}
